import { TranslationKeys } from '@eventbrite/good-to-know';
import { gettext } from '@eventbrite/i18n';
import { type LocationProps } from '../EventDetails/WhenAndWhere/Location/Location';

export const getTranslations = (location?: LocationProps): TranslationKeys => {
    const isTBDLocation =
        location && !location.isOnlineEvent && !location.hasAddress;

    return {
        goodToKnow: gettext('Good to know').toString(),
        refundPolicy: gettext('Refund Policy').toString(),
        viewAll: gettext('View all').toString(),
        highlights: gettext('Highlights').toString(),
        inPerson: isTBDLocation
            ? gettext('To be announced').toString()
            : gettext('In person').toString(),
        online: gettext('Online').toString(),
        scrollLeft: gettext('Scroll carousel left').toString(),
        scrollRight: gettext('Scroll carousel right').toString(),
        freeParking: gettext('Free parking').toString(),
        paidParking: gettext('Paid parking').toString(),
        readMore: gettext('Read more').toString(),
    };
};
